export default "__VITE_ASSET__DJczclcm__"